import { useAuthStore } from './authStore';

export const getToken = (): string | null => {
  return useAuthStore.getState().token;
};

export const getAuthId = (): string | null => {
  return useAuthStore.getState().authId;
};

export const getUserId = (): string | null => {
  return useAuthStore.getState().userId;
};

export const getOrgId = (): string | null => {
  return useAuthStore.getState().orgId;
};

export const getOrgName = (): string | null => {
  return useAuthStore.getState().orgName;
};

export const getRegion = (): string | null => {
  return useAuthStore.getState().region;
};

export const getRole = (): string | null => {
  return useAuthStore.getState().role;
};

export const getTeam = (): string | null => {
  return useAuthStore.getState().team;
};

export const getUserTitle = (): string | null => {
  return useAuthStore.getState().userTitle;
};

export const getAuthHeaders = (): Record<string, string> => {
  const token = getToken();
  return {
    ...(token ? { authorization: `bearer ${token}` } : {}),
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
};

export const isAuthenticated = (): boolean => {
  return !!getToken();
};
